import React, { useState, useRef, useEffect } from "react";
import TabList from "../../Components/TabList";
import Grid from "@mui/material/Grid";

//Components
import Header from "../../Components/Header";
// import Footer from '../../Components/Footer';

const Home = () => {
  const childRef = useRef();
  const fetchMonthlyTransaction = () => {
    childRef.current.callFromTransaction();
  };

  return (
    <>
      <Header fetchMonthlyTransaction={fetchMonthlyTransaction} />
      {/* <Grid container>
        <Grid className="bg-color2" item xs={4}></Grid>
        <Grid className="bg-color2" item xs={4}></Grid>
      </Grid> */}
      <Grid container>
        <Grid item xs={12} style={{ marginTop: "0px", height: "90vh" }}>
          <TabList ref={childRef} />
        </Grid>
      </Grid>

      {/* <Footer/> */}
    </>
  );
};

export default Home;
